<section class="custom-carousel imagelinklist--content-embedded h--center v--center image--slider" aria-label="Saudia Business promotional banner">
  <div class="swiper-container" aria-label="Promotional carousel">
    <div class="swiper-slide alfursan-program-guest">
      <div class="swiper-slide__image desktop-view">
        <img src="assets/images/landing-banner.png" alt="Saudia Business program promotional banner showing benefits and services" width="1920" height="422" />
      </div>

      <div class="container alfursan-program-guest">
        <div class="swiper-slide__content">
          <h1>
            {{dictionaryContent?.['b2b.saudiabusiness'] || 'Saudia Business'}}
          </h1>
          <div class="swiper-slide__desc" aria-live="polite">
            <span>
              {{content?.['b2b.register.saudismedesc']}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
